import {
  BuildingPartCollectionFragment,
  HourSeriesCollectionFragment,
  HourSeriesCollectionType,
  HourSeriesType,
  OriginalGlobalCollectionFragment,
} from '../generated/graphql'

// Check HourSeriesCollection.validate for shape of different type collections in db

type ValidBuildingPart = Pick<
  BuildingPartCollectionFragment,
  'id' | 'name' | 'hourSeries'
> & {
  type: HourSeriesCollectionType.BuildingPart
  partArea: number
}

export function isValidPart(
  part: BuildingPartCollectionFragment,
): part is ValidBuildingPart {
  return (
    part.type === HourSeriesCollectionType.BuildingPart &&
    Boolean(part.partArea)
  )
}

export type ValidAutogeneratedForTemperaturesCollection =
  HourSeriesCollectionFragment & {
    originalGlobalCollection: OriginalGlobalCollectionFragment
  }

export function isValidAutogeneratedForTemperaturesCollection(
  collection: HourSeriesCollectionFragment,
): collection is ValidAutogeneratedForTemperaturesCollection {
  return (
    collection.type === HourSeriesCollectionType.AutogeneratedForTemperatures &&
    Boolean(collection.originalGlobalCollection)
  )
}

export function createFilterOutAutogeneratedHourSeriesFromTemplate(
  autogeneratedCollections: ValidAutogeneratedForTemperaturesCollection[],
) {
  return (
    template: HourSeriesCollectionFragment,
  ): HourSeriesCollectionFragment => ({
    ...template,
    hourSeries: template.hourSeries.filter(
      (hourSeries) =>
        !autogeneratedCollections.some(
          (autogenerated) =>
            template.id === autogenerated.originalGlobalCollection.id &&
            autogenerated.hourSeries.some(
              (autogeneratedHourSeries) =>
                autogeneratedHourSeries.name === hourSeries.name,
            ),
        ),
    ),
  })
}

export function hasBuildingPartTemplates(
  collection: HourSeriesCollectionFragment,
): collection is ValidAutogeneratedForTemperaturesCollection {
  return collection.hourSeries.some(
    (hourSeries) =>
      hourSeries.type === HourSeriesType.HeatingDemandDensity ||
      hourSeries.type === HourSeriesType.CoolingDemandDensity ||
      hourSeries.type === HourSeriesType.ElectricityDemandDensity,
  )
}

const hourSeriesCollectionTypeToPriorityMap: Record<
  HourSeriesCollectionType,
  number
> = {
  [HourSeriesCollectionType.Global]: 400,
  [HourSeriesCollectionType.ProjectSpecific]: 100,
  [HourSeriesCollectionType.BuildingPart]: 200,
  [HourSeriesCollectionType.AutogeneratedForTemperatures]: 300,
  // [HourSeriesCollectionType.BuildingEnergy]: 500,
}

export function sortHourSeriesCollections(
  a: HourSeriesCollectionFragment,
  b: HourSeriesCollectionFragment,
): number {
  if (a.type === b.type) {
    if (a.name === b.name) {
      return 0
    }

    return a.name > b.name ? 1 : -1
  }

  return hourSeriesCollectionTypeToPriorityMap[a.type] >
    hourSeriesCollectionTypeToPriorityMap[b.type]
    ? 1
    : -1
}
